import { ID_RE, USERNAME } from 'mk2/helpers/urls';

const KID_ID = `:kidId(${ID_RE})`;

export const settingsUrl = '/settingsapp/';

export const settingsPhoneUrl = `/settingsapp/${USERNAME}/phone/`;
export const settingsSignupUrl = `/settingsapp/signup/`;

export const settingsProfileUrl = `/settingsapp/${USERNAME}/profile/`;

export const settingsKidsUrl = `/settingsapp/${USERNAME}/kids/`;
export const settingsKidAddUrl = `/settingsapp/${USERNAME}/kid/add/:sex(boy|girl)/`;
export const settingsKidEditUrl = `/settingsapp/${USERNAME}/kid/edit/${KID_ID}/`;

export const settingsAccountUrl = `/settingsapp/${USERNAME}/account/`;
